import { cssVarColors } from 'lib/cssSelector'
import { Styles } from 'react-jss'
const { gray, main } = cssVarColors

export const sheet: Styles = {
  radioInput: {},
  activeRadio: {},
  radioChacked: {
    border: `2px solid ${main} !important`
  },
  radio: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '14px',
    border: `2px solid ${gray}`,
    borderRadius: '4px',
    '&:hover': {
      border: `2px solid ${main} !important`
    },
    '& > $radioInput': {
      position: 'absolute',
      opacity: 0,
      '& + label': {
        position: 'relative',
        cursor: 'pointer',
        padding: 0,
        gap: '5px'
      },
      '& + label:before': {
        content: '""',
        marginRight: 20,
        display: 'inline-block',
        verticalAlign: 'text-top',
        width: 20,
        height: 20,
        background: '#FFFFFF',
        border: '1px solid #000000',
        boxSizing: 'border-box',
        borderRadius: 1
      },
      '&:checked, &:not(:checked)': {
        position: 'absolute',
        left: '-9999px'
      },
      '&:checked + label, &:not(:checked) + label': {
        position: 'relative',
        paddingLeft: '60px',
        cursor: 'pointer'
      },
      '&:checked + label:before, &:not(:checked) + label::before': {
        content: '""',
        position: 'absolute',
        left: 10,
        top: 0,
        bottom: 0,
        margin: 'auto',
        width: 24,
        height: 24,
        border: '2px solid #CCCCCC',
        boxSizing: 'border-box',
        borderRadius: '100%'
      },
      '&:checked + label:after, &:not(:checked) + label:after': {
        content: '""',
        position: 'absolute',
        transition: 'all 0.2s ease',
        left: 15,
        top: 0,
        bottom: 0,
        margin: 'auto',
        width: 14,
        height: 14,
        borderRadius: '100%',
        backgroundColor: main
      },
      '&:not(:checked) + label:after': {
        opacity: 0
      },
      '&:checked + label:after': {
        opacity: 1
      },
      '&:checked + label:before': {
        border: `2px solid ${main}`
      }
    }
  }
}
